/**
 *
 */
export const DESIGN_TYPE_NAME = {
  MOBILE: 'mobile',
  LAPTOP: 'laptop',
}
